// import React from 'react';
// import './GovernorViceChancellor.css';

// const GovernorViceChancellor = () => {
//   const leaders = [
//     {
//       id: 1,
//       name: "Shri S. Abdul Nazeer",
//       position: "Hon'ble Chancellor",
//       subPosition: "Hon'ble Governor of Andhra Pradesh",
//       image: "/person/apgoverner.jpg",
//       description: "",
//       link: "https://www.apgovernor.gov.in/"
//     },
//     {
//       id: 2,
//       name: "Prof. V. Venkata Basava Rao",
//       position: "Hon'ble Vice Chancellor",
//       subPosition: "Rayalaseema University",
//       image: "/person/vicechancellor2.JPG",
//       description: "",
//       link: "/administration/vice-chancellor"
//     }
//   ];

//   return (
//     <section className="governor-vc-section">
//       <div className="container">
//         <div className="section-header">
//           <h2>University Leadership</h2>
//           <p>Meet our esteemed Chancellor and Vice Chancellor</p>
//           <div className="header-underline"></div>
//         </div>
        
//         <div className="leaders-container">
//           {leaders.map((leader) => (
//             <div key={leader.id} className="leader-card">
//               <div className="leader-image-container">
//                 <div className="leader-image">
//                   <img src={leader.image} alt={leader.name} />
//                   <div className="image-overlay"></div>
//                 </div>
//               </div>
              
//               <div className="leader-info">
//                 <div className="leader-content">
//                   <h3 className="leader-name">{leader.name}</h3>
//                   <h4 className="leader-position">{leader.position}</h4>
//                   {leader.subPosition && (
//                     <h5 className="leader-sub-position">{leader.subPosition}</h5>
//                   )}
//                   {leader.link && (
//                     <div className="leader-button-container">
//                       <a 
//                         href={leader.link} 
//                         className="leader-button"
//                         target={leader.link.startsWith('http') ? '_blank' : '_self'}
//                         rel={leader.link.startsWith('http') ? 'noopener noreferrer' : undefined}
//                       >
//                         Learn More
//                       </a>
//                     </div>
//                   )}
//                   <p className="leader-description">{leader.description}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default GovernorViceChancellor;
import React from "react";
import "./GovernorViceChancellor.css";

const GovernorViceChancellor = () => {
  const leaders = [
    {
      id: 1,
      name: "Shri S. Abdul Nazeer",
      position: "Hon'ble Chancellor",
      subPosition: "Hon'ble Governor of Andhra Pradesh",
      image: "/person/apgoverner.jpg",
      link: "https://www.apgovernor.gov.in/"
    },
    {
      id: 2,
      name: "Prof. V. Venkata Basava Rao",
      position: "Hon'ble Vice Chancellor",
      subPosition: "Rayalaseema University",
      image: "/person/vicechancellor2.JPG",
      link: "/administration/vice-chancellor"
    }
  ];

  return (
    <section className="gvc-section">
      <div className="gvc-container">

        <div className="gvc-header">
          <h2>University Leadership</h2>
          <p>Meet our esteemed Chancellor and Vice Chancellor</p>
          <div className="gvc-underline"></div>
        </div>

        <div className="gvc-grid">
          {leaders.map((leader) => (
            <div key={leader.id} className="gvc-card">

              <div className="gvc-image-wrapper">
                <img src={leader.image} alt={leader.name} />
              </div>

              <div className="gvc-info">
                <h3 className="gvc-name">{leader.name}</h3>
                <p className="gvc-position">{leader.position}</p>
                <p className="gvc-sub-position">{leader.subPosition}</p>

                <a
                  href={leader.link}
                  className="gvc-btn"
                  target={leader.link.startsWith("http") ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                >
                  Learn More
                </a>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default GovernorViceChancellor;
